import React from "react";
import ProjectCaseStudyWrapper from "./projCaseStudy";

const AboutUsWrapper = () => {
  return (
    <section className="revamp-why-us">
        <div className="container">
            <div className="row">
                <div className="col-xl-6 col-lg-6 col-12 pr-xl-5">
                    <div className="section-title mb-30">
                        <span className="revamp-section-badge revamp-reveal" style={{marginBottom: '30px', display: 'inline-block'}}>Why Choose Us</span>
                        <h2 className="revamp-section-title revamp-reveal">Driving Innovation With Purpose</h2>
                    </div>

                    <p className="pr-md-5 revamp-reveal" style={{lineHeight: '1.8'}}>At Abia Tech Hub, we go beyond delivering solutions. We build people, ideas, and opportunities. We combine technical expertise with creativity and entrepreneurial thinking to help individuals and businesses thrive in a digital world.
<br />
Our strength lies in our community, our commitment to excellence, and our ability to turn ideas into real impact. We don&apos;t just work with you. We grow with you.</p>
                    
                    <div className="revamp-checklist revamp-reveal">
                        <ul>
                            <li>Expertise</li>
                            <li>Innovative solutions</li>
                            <li>Quality service</li>
                            <li>Reputation and track record</li>
                        </ul>
                    </div>

                </div>

                <div className="col-xl-6 col-md-10 col-lg-6 pl-xl-5 col-12 mt-5 mt-xl-0">
                    <div className="about-thum">
                        <div className="item top-image text-right revamp-reveal">
                            <img src="assets/new-images/_MG_5654.jpg" alt="ATH founder with team member" style={{borderRadius: '16px', marginBottom: '16px', maxWidth: '100%'}}/>
                        </div>
                        <div className="item buttom-image text-end revamp-reveal">
                            <img src="assets/new-images/3-people-group-pic.jpg" alt="ATH team group" style={{borderRadius: '16px', maxWidth: '80%'}}/>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <ProjectCaseStudyWrapper />
    </section>
  );
};

export default AboutUsWrapper;